<template>
  <div>
    <div class="mb-2 mt-5 d-flex gap-3 align-items-center">
      <h3>
        {{ $t("signup.contract_review_component.documents_review_title") }}
      </h3>
      <!-- Signing status badge -->
      <div class="text-center text-md-start">
        <span
          v-if="documentStatus === 'completed'"
          class="badge badge-phoenix badge-phoenix-success fs-10 p-1 px-3"
        >
          <FontAwesomeIcon icon="check" />
          {{ $t("document.signed") }}
        </span>
        <span
          v-else
          class="badge badge-phoenix badge-phoenix-primary fs-10 p-1 px-3"
        >
          <FontAwesomeIcon icon="file-signature" />
          {{ $t("document.awaiting_signature") }}
        </span>
      </div>
    </div>
    <p>
      {{ $t("signup.contract_review_component.documents_review_subtext") }}
    </p>
    <InfoCardComponent
      v-for="contract in contracts"
      :key="contract.contract_key"
      :buttonText="$t('common.read_more_button')"
      :clickArea="isAdmin ? 'button' : 'title'"
      :containerClass="'m-0 rounded-0 border-end-0 border-start-0'"
    >
      <template #title>
        <div class="avatar avatar-x1 me-2" v-if="!isAdmin">
          <font-awesome-icon icon="sheet-plastic" />
        </div>
        <div class="form-check admin-checkbox" v-if="isAdmin">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="contract.include"
            :disabled="!contract.can_include"
          />
        </div>
        <div
          class="flex-1"
          :class="{
            'fw-bold text-body-emphasis': contract.include,
            'text-secondary-light': !contract.include,
          }"
        >
          {{ $t(contract.meta.title) }}
        </div>
      </template>
      <template #content>
        <div class="text-body-secondary">
          {{ $t(contract.meta.description) }}
        </div>
      </template>
    </InfoCardComponent>
  </div>
</template>

<script setup lang="ts">
import InfoCardComponent from "@/components/common/InfoCardComponent.vue";
import { Contract } from "@/types"; // Import from central types file
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

withDefaults(
  defineProps<{
    isAdmin?: boolean;
    documentStatus?: "completed" | "awaiting_signature" | string;
  }>(),
  {
    isAdmin: false,
    documentStatus: "awaiting_signature",
  }
);

const contracts = defineModel<Contract[]>("contracts", { required: true });
</script>

<style scoped lang="scss">
.admin-checkbox {
  padding: 0.5rem;
  border: 3px dashed var(--phoenix-warning-border-subtle);
  display: flex;
  background-color: var(--phoenix-warning-bg-subtle);
  margin: 0;
  margin-right: 0.5rem;
  input {
    margin: 0;
    &:checked {
      background-color: var(--phoenix-warning-text-emphasis);
      border: 3px solid var(--phoenix-warning-border);
    }
  }
}

.text-secondary-light {
  color: var(--phoenix-secondary-color);
}
</style>
